import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home'
import PersonalInformation from '../pages/UserDetails/PersonalInformation';
import EKyc from '../pages/UserDetails/EKyc';
import BankDetails from '../pages/UserDetails/BankDetails';
import EmploymentDetails from '../pages/UserDetails/EmploymentDetails';
import LandingPage from '../pages/LandingPage';
import MyAccount from '../pages/MyAccount';
import { DashboardRoutesLinks, RoutesLink } from './RoutesLink';
import MyLoans from '../pages/MyLoans';
import Documents from '../pages/Documents';
import { CreaditTools } from '../pages/CreditTools';
import { LoanProductPage } from '../pages/LoanProduct/LoanProductPage';
import { LendingPartners } from '../pages/lendingPartners/LendingPartners';
import { Blogs } from '../pages/Blogs/Blogs';
import { ContactPage } from '../pages/Contact/Contact';
import { SupportPage } from '../pages/Support/SuportPage';
import { AboutUs } from '../pages/AboutUs/AboutUs';
import OnBoardingModule from '../pages/LandingPage/components/OnBoardingModule';

const AppRouter = () => {
  const DashboardRoutesList = [
    { path: DashboardRoutesLinks?.dashboard, element: <Home /> },
    { path: DashboardRoutesLinks?.personalInformation, element: <PersonalInformation /> },
    { path: DashboardRoutesLinks?.ekyc, element: <EKyc /> },
    { path: DashboardRoutesLinks?.bankDetails, element: <BankDetails /> },
    { path: DashboardRoutesLinks?.employmentDetails, element: < EmploymentDetails /> },
    { path: DashboardRoutesLinks?.myAccount, element: <MyAccount /> },
    { path: DashboardRoutesLinks?.documents, element: <Documents /> },
    { path: DashboardRoutesLinks?.myLoans, element: <MyLoans /> }]
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/credit-tools" element={<CreaditTools />} />
        <Route path="/loan-products" element={<LoanProductPage />} />
        <Route path="/home" element={<Home />} />
        {DashboardRoutesList?.map((route) => <Route path={route?.path} element={route?.element} />)}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/lending-partners" element={<LendingPartners />} />
        <Route path="/Blogs" element={<Blogs />} />
        <Route path="/about-us" element={<AboutUs />} />

      </Routes>
      <OnBoardingModule />
    </Router>
  );
};

export default AppRouter;